import logError from '../logError/logError';

let attemptLeft = 3;

const isChunkLoadError = (error: Error) =>
  error.name === 'ChunkLoadError' ||
  /Failed to fetch dynamically imported module/i.test(error.message) ||
  /Importing a module script failed/i.test(error.message) ||
  /error loading dynamically imported module/i.test(error.message);

const fetchErrorHandler = (error: Error) => {
  if (isChunkLoadError(error) && attemptLeft) {
    if (attemptLeft % 2 === 0) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.location.reload(true);
    } else {
      // eslint-disable-next-line no-self-assign
      window.location.href = window.location.href;
    }
    attemptLeft -= 1;
    logError(error, `chunk fetching: reloading ${attemptLeft - 3} time`);
  } else {
    logError(error, 'chunk fetching: no attemptLeft');
  }
};

export { isChunkLoadError };
export default fetchErrorHandler;
